module.exports = __webpack_public_path__ + "static/img/bcg.5aa9d13f.jpg";